import { useLayoutEffect, useState } from "react";
import { isMobile } from "react-device-detect";

export const useIsMobile = () => {
  const [isMobileLoaded, setIsMobileLoaded] = useState(false);

  useLayoutEffect(() => {
    setIsMobileLoaded(true);
  }, []);

  if (isMobileLoaded) return isMobile;
};
